/**
 * ConceptBrowserPage — standalone page wrapper for the ConceptBrowser component.
 * Provides the same sidebar layout as PagesRoute.
 */

import React from 'react';
import { PagesProvider } from '../../state/pages-context';
import { LibrarySidebar } from './LibrarySidebar';
import { ConceptBrowser } from './ConceptBrowser';

function ConceptBrowserContent(): React.ReactElement {
  return (
    <div className="flex flex-1 overflow-hidden">
      {/* Sidebar */}
      <aside className="w-64 shrink-0 border-r bg-muted/30 overflow-y-auto" aria-label="Pages sidebar">
        <LibrarySidebar />
      </aside>

      {/* Content area */}
      <main className="flex-1 overflow-hidden" aria-label="Concept browser">
        <ConceptBrowser />
      </main>
    </div>
  );
}

export function ConceptBrowserPage(): React.ReactElement {
  return (
    <PagesProvider>
      <div className="flex flex-col h-[calc(100vh-3.5rem)]">
        <ConceptBrowserContent />
      </div>
    </PagesProvider>
  );
}
